import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { loginPageTranslations } from './auth/loginPage';
import { registerPageTranslations } from './auth/registerPage';
import { registerSetupPageTranslations } from './auth/signUpSetupStage';
import { fightHistoryStageTranslations } from './auth/fightHistoryStage';
import { fightersPageTranslations } from './fighters/fightersPageTranslations';
import { managersPageTranslations } from './managers/managersPageTranslations';
import { notificationsPageTranslations } from './notification/notificationTranslations';
import { sidebarTranslations } from './sidebar/sidebarTranslations';
import { settingsTranslations } from './settings/settingsTranslation';
import { viewProfileTranslations } from './viewProfile/viewProfileTranslation';
import { publicProfileTranslations } from './viewProfile/publicProfileTranslation';
import { dashboardTranslations } from './dashboard/dashboardTranslation';
import ReadyRoster from '../pages/readyRoster/readyRoster';
import ReadyRosterTranslations from './fighters/readyRosterTranslations';
import { opportunitiesTranslations } from './managers/opportunitiesTranslations';
import { CreateEditReadyRosterTranslations } from './fighters/createEditReadyRosterTranslations';
import { createEditOpportunitiesTranslations } from './managers/createEditOpportunitiesTranslations';
import { reportAbusePopupTranslations } from './abuseReport/reportAbusePopupTranslations';
import { ChatTranslations } from './chat/chatTranslations';
import { addOrEditGroupTranslations } from './chat/addOrEditGroupTranslations';
import { historyTranslations } from './history/historyTranslations';
import { editProfileStatusTranslations } from './viewProfile/profileStatus';
import { dealAccordionTranslations } from './deal/dealAccordionTranslation';
import { updateProfileTranslations } from './viewProfile/updateProfileTranslations';
import { viewDealTranslations } from './deal/viewDealTranslations';
import { dealModalTranslations } from './deal/dealModalTranslations';
import { addPeopleTranslations } from './chat/addPeopleTranslation';
import { socialMediaSectionTranslations } from './viewProfile/socialMediaTranslations';
import { feedsTranslations } from './feed/feedsTranslations';
import { marketPlaceCardsTranslations } from './marketPlaceCards/marketPlaceCardsTranslations';
import { eventsTranslations } from './events/eventsTranslations';



const resources = {
    en: {
        login: loginPageTranslations.en,
        register: registerPageTranslations.en,
        signUpSetupStages: registerSetupPageTranslations.en,
        signUpSetupLogic: registerSetupPageTranslations.en,
        fighthistory: fightHistoryStageTranslations.en,
        fighters: fightersPageTranslations.en,
        managers: managersPageTranslations.en,
        notifications: notificationsPageTranslations.en,
        sidebar: sidebarTranslations.en,
        settings: settingsTranslations.en,
        viewProfile: viewProfileTranslations.en,
        publicProfile: publicProfileTranslations.en,
        dashboard: dashboardTranslations.en,
        readyRoster: ReadyRosterTranslations.en,
        opportunities: opportunitiesTranslations.en,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.en,
        CreateEditOpportunities: createEditOpportunitiesTranslations.en,
        reportAbusePopup: reportAbusePopupTranslations.en,
        dealModal: dealModalTranslations.en,
        chat: ChatTranslations.en,
        addOrEditGroup: addOrEditGroupTranslations.en,
        history: historyTranslations.en,
        viewDeal: viewDealTranslations.en,
        editProfileStatus: editProfileStatusTranslations.en,
        dealAccordion: dealAccordionTranslations.en,
        updateProfile: updateProfileTranslations.en,
        addPeople: addPeopleTranslations.en,
        socialMediaSection: socialMediaSectionTranslations.en,
        feeds: feedsTranslations.en,
        marketPlaceCards: marketPlaceCardsTranslations.en,
        events: eventsTranslations.en
    },
    de: {
        login: loginPageTranslations.de,
        register: registerPageTranslations.de,
        signUpSetupStages: registerSetupPageTranslations.de,
        signUpSetupLogic: registerSetupPageTranslations.de,
        fighthistory: fightHistoryStageTranslations.de,
        fighters: fightersPageTranslations.de,
        managers: managersPageTranslations.de,
        notifications: notificationsPageTranslations.de,
        sidebar: sidebarTranslations.de,
        settings: settingsTranslations.de,
        viewProfile: viewProfileTranslations.de,
        publicProfile: publicProfileTranslations.de,
        dashboard: dashboardTranslations.de,
        readyRoster: ReadyRosterTranslations.de,
        opportunities: opportunitiesTranslations.de,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.de,
        CreateEditOpportunities: createEditOpportunitiesTranslations.de,
        reportAbusePopup: reportAbusePopupTranslations.de,
        dealModal: dealModalTranslations.de,
        chat: ChatTranslations.de,
        addOrEditGroup: addOrEditGroupTranslations.de,
        history: historyTranslations.de,
        viewDeal: viewDealTranslations.de,
        editProfileStatus: editProfileStatusTranslations.de,
        dealAccordion: dealAccordionTranslations.de,
        updateProfile: updateProfileTranslations.de,
        addPeople: addPeopleTranslations.de,
        socialMediaSection: socialMediaSectionTranslations.de,
        feeds: feedsTranslations.de,
        marketPlaceCards: marketPlaceCardsTranslations.de,
        events: eventsTranslations.de
    },
    hr: {
        login: loginPageTranslations.hr,
        register: registerPageTranslations.hr,
        signUpSetupStages: registerSetupPageTranslations.hr,
        signUpSetupLogic: registerSetupPageTranslations.hr,
        fighthistory: fightHistoryStageTranslations.hr,
        fighters: fightersPageTranslations.hr,
        managers: managersPageTranslations.hr,
        notifications: notificationsPageTranslations.hr,
        sidebar: sidebarTranslations.hr,
        settings: settingsTranslations.hr,
        viewProfile: viewProfileTranslations.hr,
        publicProfile: publicProfileTranslations.hr,
        dashboard: dashboardTranslations.hr,
        readyRoster: ReadyRosterTranslations.hr,
        opportunities: opportunitiesTranslations.hr,
        CreateEditReadyRoster: CreateEditReadyRosterTranslations.hr,
        CreateEditOpportunities: createEditOpportunitiesTranslations.hr,
        reportAbusePopup: reportAbusePopupTranslations.hr,
        dealModal: dealModalTranslations.hr,
        chat: ChatTranslations.hr,
        addOrEditGroup: addOrEditGroupTranslations.hr,
        history: historyTranslations.hr,
        viewDeal: viewDealTranslations.hr,
        editProfileStatus: editProfileStatusTranslations.hr,
        dealAccordion: dealAccordionTranslations.hr,
        updateProfile: updateProfileTranslations.hr,
        addPeople: addPeopleTranslations.hr,
        socialMediaSection: socialMediaSectionTranslations.hr,
        feeds: feedsTranslations.hr,
        marketPlaceCards: marketPlaceCardsTranslations.hr,
        events: eventsTranslations.hr
    },

};

const getUserLanguage = (): string => {
    const userJson = localStorage.getItem('loginResponse');
    const user = userJson ? JSON.parse(userJson) : null;
    return user?.preferredLanguage || "";
};


i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem(getUserLanguage() || 'i18nextLng') || 'en',
    fallbackLng: 'en',
    ns: ['login', 'register', 'signUpSetupStages', 'dealAccordion', 'viewDeal', 'signUpSetupLogic', 'addOrEditGroup', 'fighthistory', 'fighters', 'managers', 'notifications', 'sidebar', 'settings', 'viewProfile', 'publicProfile', 'dashboard', 'readyRoster', 'opportunities', 'updateProfile', 'CreateEditReadyRoster', 'CreateEditOpportunities', 'reportAbusePopup', 'dealModal', 'chat', 'addPeople', 'history', 'editProfileStatus', 'socialMediaSection', 'basicInfoSection', 'feeds', 'marketPlaceCards', 'events'],
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;

